import React, { useState, useEffect } from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';

import ProjectSettingCoverTitleStep from 'components/containers/group/project/ProjectSettingCoverTitleStep';
import ProjectSettingDescriptionStep from 'components/containers/group/project/ProjectSettingDescriptionStep';
import ProjectSettingPeriodStep from 'components/containers/group/project/ProjectSettingPeriodStep';
import ProjectSettingTodoListStep from 'components/containers/group/project/ProjectSettingTodoListStep';
import ProjectSettingSampleProofStep from 'components/containers/group/project/ProjectSettingSampleProofStep';

import serverController from 'server/serverController';
import server from 'server/serverController2';

import { useHistory } from 'react-router-dom';

export default function UpdateGroupProjectLayout({ match }) {
  const history = useHistory();

  const [redirectURL, setRedirectURL] = useState('/');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [fitIntroductContent, setFitIntroductContent] = useState('');
  const [screenIndex, setScreenIndex] = useState(0);

  const [isInitCoverImg, setIsInitCoverImg] = useState(false);
  const [initCoverImg, setInitCoverImg] = useState(null);

  const [projectImg, setProjectImg] = useState(null);
  const [projectTitle, setProjectTitle] = useState('');
  const [projectInfo, setProjectInfo] = useState('');

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [periodCheck, setPeriodCheck] = useState('');

  const [dayOfWeek, setDayOfWeek] = useState([]);
  const [images, setImages] = useState(null);
  const [inputlist, setInputlist] = useState([]);

  const [removedTaskList, setRemovedTaskList] = useState([]);

  let newCoverImg = null;

  // 프로젝트 상세 데이터
  const [grouProjectInfo, setGrouProjectInfo] = useState({});
  const infoCallBack = (res) => {
    if (res.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.');
      return;
    }
    let jsonData = res.data;

    if (jsonData['cover_img']) {
      setIsInitCoverImg(true);
      setInitCoverImg(jsonData['cover_img']);
    }

    setGrouProjectInfo(jsonData);
    setProjectTitle(jsonData.title);
    setProjectInfo(jsonData.description);
    setStartDate(jsonData.start_date);
    setEndDate(jsonData.end_date);
    if (jsonData['day']) {
      setDayOfWeek(jsonData.day);
    }

    if (jsonData['token']) {
      setRedirectURL(
        `/group/${jsonData.group_no}/project/${match.params.project_no}?token=${jsonData['token']}`,
      );
    } else {
      setRedirectURL(`/group/${jsonData.group_no}/project/${match.params.project_no}`);
    }
    setInputlist(jsonData.tasks);
  };

  //페이지가 렌더링이 되었을 때 한번 호출
  useEffect(() => {
    serverController.getServerData(
      `groups/projects/${match.params.project_no}`,
      infoCallBack,
    );
  }, []);

  //프로젝트 수정
  const callBack = (res) => {
    if (res.success === 1) {
      history.replace(redirectURL);
    } else {
      alert('예기치 못한 오류가 발생하였습니다.');
    }
  };
  const uploadCoverImgCallBack = (res) => {
    if (
      res.data &&
      res.data.upload_results &&
      res.data.upload_results.length > 0
    ) {
      newCoverImg = res.data.upload_results[0]['file_name'];
    }
  };


  /*--click block--*/
  const dataSubmit = async () => {
    try {
      if (isSubmitting) {
        return;
      }
      setIsSubmitting(true);

      if (!projectImg && !initCoverImg) {
        alert('이미지를 선택해주세요');
      }

      if (projectImg) {
        let formData = new FormData();
        formData.append('file', projectImg);
        formData.append('path', 'group_project_cover_img/');
        await serverController.updatefilePostFetchController(
          `file`,
          formData,
          uploadCoverImgCallBack,
        );
      }

      //task list handling
      //Exec Removed Todolist
      for (let i = 0; i < removedTaskList.length; ++i) {
        let currRemoveTarget = removedTaskList[i];
        await serverController.asyncDeleteFetchController(
          `groups/projects/tasks/${currRemoveTarget['no']}`,
          JSON.stringify({}),
        );
      }

      //Exec New Todolist
      for (let i = 0; i < inputlist.length; ++i) {
        let currentTaskItem = inputlist[i];
        currentTaskItem['start_date'] = startDate;
        currentTaskItem['end_date'] = endDate;
        currentTaskItem['day'] = dayOfWeek;
        if (!inputlist[i]['no']) {
          await serverController.asyncPostFetchController(
            `groups/projects/${match.params.project_no}/tasks`,
            JSON.stringify(currentTaskItem),
          );
        } else {
          await serverController.asyncPutFetchController(
            `groups/projects/tasks/${inputlist[i]['no']}`,
            JSON.stringify(currentTaskItem),
          );
        }
      }
      // task list handling end

      let uploadedSampleProof = [];
      if (images && Array.isArray(images)) {
        let formData = new FormData();
        for (let i = 0; i < images.length; i++) {
          formData.append('file', images[i]);
        }

        formData.append('path', 'group_project_sample_proof_img/');
        let response = await server.postRequestFormData(
            `file`,
            formData
          );
        if(response['success'] === 1)
        {
          let uploadResult = response['data']['upload_results'];
          for(let i = 0; i < uploadResult.length; ++i)
          {
            uploadedSampleProof.push(uploadResult[i]['file_name']);
          }
        }
      }
      let serverData = {
        title: projectTitle,
        description: projectInfo,
        start_date: startDate,
        end_date: endDate,
        day: dayOfWeek,
        // tasks:
      };

      if(uploadedSampleProof.length > 0)
      {
        serverData['sample_proof'] = uploadedSampleProof;
      }
      if (newCoverImg) {
        serverData['cover_img'] = newCoverImg;
      }
      await serverController.generalPutFetchController(
        `groups/projects/${match.params.project_no}`,
        JSON.stringify(serverData),
        callBack,
      );

      setIsSubmitting(false);
    } catch (err) {
      console.log(err);
      setIsSubmitting(false);
    }
  };

  const updateNext = (index) => {
    // 페이지 더 생성되면 숫자 늘려나가기
    if (screenIndex + index === -1 || screenIndex + index > 4) return;

    setScreenIndex(screenIndex + index);
  };

  let renderPageController = () => {
    switch (screenIndex) {
      case 0:
        return (
          <ProjectSettingCoverTitleStep
            fitIntroductContent={fitIntroductContent}
            updateNext={updateNext}
            setFitIntroductContent={setFitIntroductContent}
            titname={'프로젝트 이름 '}
            subtit={'모임 내에서 세부적인 프로젝트들을 진행 할 수 있어요!'}
            marginTop={'calc(100vw*(-10/375));'}
            paddingBottom={'calc(100vw*(15/375))'}
            placeholder={'ex) 매일 10분 하체 스트레칭'}
            projectImg={projectImg}
            setProjectImg={setProjectImg}
            projectTitle={projectTitle}
            setProjectTitle={setProjectTitle}
            grouProjectInfo={grouProjectInfo}
            isInitCoverImg={isInitCoverImg}
            setIsInitCoverImg={setIsInitCoverImg}
            initCoverImg={initCoverImg}
          />
        );
      case 1:
        return (
          <ProjectSettingDescriptionStep
            updateNext={updateNext}
            title={'프로젝트 소개'}
            infotext={
              '본인 프로젝트에 대한 간단한 소개 및 주의사항 / 가이드라인을 제시해 주세요'
            }
            placeholder={
              'ex) 이 프로젝트는 매일 간단하게 스트레칭을 하는 프로젝트입니다. 매일 10분씩 인증해 주시면 됩니다.'
            }
            projectInfo={projectInfo}
            setProjectInfo={setProjectInfo}
            grouProjectInfo={grouProjectInfo}
          />
        );
      case 2:
        return (
          <ProjectSettingPeriodStep
            updateNext={updateNext}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            periodCheck={periodCheck}
            setPeriodCheck={setPeriodCheck}
            dayOfWeek={dayOfWeek}
            setDayOfWeek={setDayOfWeek}
          />
        );
      case 3:
        return (
          <ProjectSettingTodoListStep
            updateNext={updateNext}
            inputlist={inputlist}
            setInputlist={setInputlist}
            removedTaskList={removedTaskList}
            setRemovedTaskList={setRemovedTaskList}
          />
        );
      case 4:
        return (
          <ProjectSettingSampleProofStep
            updateNext={updateNext}
            dataSubmit={dataSubmit}
            images={images}
            setImages={setImages}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <TitleHeader
        isCloseBtn={true}
        title={'프로젝트 수정'}
        borderbottom={'solid 1px #d5d5d5'}
      />
      {renderPageController()}

    </div>
  );
}
